/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type FileFormat = typeof FileFormat[keyof typeof FileFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileFormat = {
  Csv: 'Csv',
  Shape: 'Shape',
  Other: 'Other',
} as const;
